import { CarouselInfoCardStrings } from './index';
import { translateFn } from '../../../utils/translator.helper';

export const getCarouselInfoCardDefaultStrings = (): CarouselInfoCardStrings => ({
  nextButtonText: translateFn('Next'),
  nextTitlePrefix: translateFn('Next: '),
});
